/**
 * @Author:
 * @Description:
 * @DateTime: Created in 14:34 2020/10/13
 */

import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import './login.less';
import Input from '../../types/iview/Input';
import Button from '../../types/iview/Button';
import LoginApi, { LoginDOI, loopRequestToken } from './loginApi';
import { Toast } from '../../util/toast';
import { createBEM } from 'src/util/bem';
import Icon from 'src/types/iview/Icon';
let bem = createBEM('login');
import LocalStore from 'src/util/LocalStore';
import RouteUtils from 'src/util/routeUtils';
import { clearMenus } from '../systemConfig/roleConfig/api/roleConfigApi';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import Alert from 'src/util/alert'

@Component({ name: 'login', components: { [VueQrcode.name]: VueQrcode } })
export default class login extends Vue.Component<any> {
    loading: boolean = false;

    // 用户名密码
    username: string = '';
    password: string = '';
    // 是否展示密码
    hidePassWord: boolean = true;

    // 是否展示密码
    hidefindPassWord: boolean = true;
    hidefindPassWordConfrim: boolean = true;

    // 找回密码
    findUsername: string = '';
    findPassWord: string = '';
    findPassWordConfrim: string = '';

    // 短信验证码
    verificationCode: string = '';

    state: 'login' | 'findPassword' = 'login';

    // 剩余时间
    remainingTime: number = 0;
    // 系统名称
    system_name: string = "";
    // 英文系统名称
    english_system_name: string = "";
    // 系统logo
    logo_url: string = "";
    
    get width() {
        if (window.innerWidth <= 1366) {
            return 70;
        } else if (window.innerWidth <= 1700) {
            return 80;
        } else {
            return 90;
        }
    }

    async mounted() {
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        if (userInfo.system_name !== undefined) {
            this.system_name = userInfo.system_name;
        }
        if(userInfo.english_system_name !== undefined){
            this.english_system_name = userInfo.english_system_name;
        }
        if (userInfo.logo_url !== undefined) {

            this.logo_url = userInfo.logo_url.substring(0, userInfo.logo_url.length - 1);;
        }
    }

    async login() {
        if (!this.username) {
            return Toast.warning('请输入手机号');
        }
        if (!this.password) {
            return Toast.warning('请输入密码');
        }
        this.loading = true;
        try {
            let { code, data } = await LoginApi.login({
                username: this.username,
                passwords: this.password,
            });
            this.loading = false;
            if (code === 0) {
                if("expiration_day" in data)
                {
                    this.test();
                    alert(data["expiration_day"])
                }
                clearMenus();
                LocalStore.setData('userInfo', data);
                RouteUtils.goTo('/main');
                // loopRequestToken()
            }
        } finally {
            this.loading = false;
        }
    }

    /**
     * 发送验证码
     */
    async sendCode() {
        if (this.remainingTime > 0) {
            return 0;
        }
        if (!this.findUsername) {
            return Toast.warning('请输入手机号');
        }
        this.remainingTime = 60;
        let itv = setInterval(() => {
            this.remainingTime--;
            if (this.remainingTime === 0) {
                clearInterval(itv);
            }
        }, 1000);
        await LoginApi.getCode(this.findUsername);
    }

    async updatePassword() {
        if (!this.findUsername) {
            return Toast.warning('请输入手机号');
        }
        if (!this.verificationCode) {
            return Toast.warning('请输入验证码');
        }
        if (!this.findPassWord) {
            return Toast.warning('请输入密码');
        }
        if (!this.findPassWordConfrim) {
            return Toast.warning('请输入确认密码');
        }
        if (this.findPassWord !== this.findPassWordConfrim) {
            return Toast.warning('两次输入密码不符');
        }

        let { code } = await LoginApi.update({ passwords: this.findPassWord, mobile: this.findUsername, code: this.verificationCode });
        if (code === 0) {
            this.state = 'login';
            Toast.success('重置密码成功');
        }
    }
    
    async test(){
        window.alert = function(msg){
            var maskBg = '#0000002b';						//蒙版展示色
            var zIndex = 999999;							//修改弹出层z-index,应为最顶层,避免被覆盖
            var desColor = '#fff'						//提示信息字体颜色
            var buttonVal = '确定';							//确定按钮名称
            var btnBgColor = '#4682B4';						//确定按钮背景颜色
            var btnColor = '#fff';							//确定按钮字体颜色
            var btnAlign = 'right';							//按钮在水平位置,默认居中,变量值:left,center,right
            var style = `
                    <style class="mask-style">
                        .box-sizing{
                            box-sizing: border-box;
                        }
                        .alertMask{
                            position: fixed;	/*生成绝对定位的元素，相对于浏览器窗口进行定位*/
                            display: flex;
                            display: webkit-flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            z-index: `+zIndex+`;
                            background: `+maskBg+`;
                        }
                        .alertContainer{
                            min-width: 240px;	/*容器最小240px*/
                            max-width: 320px;	/*容器最大320px*/
                            background:#4682B4;
                            border: 1px solid `+maskBg+`;
                            border-radius: 3px;
                            color: `+desColor+`;
                            overflow: hidden;									
                        }
                        .alertDes{
                            padding: 35px 30px;
                            text-align: center;
                            letter-spacing: 1px;
                            font-size: 14px;
                            color: `+desColor+`;
                        }
                        .alertDes img{
                            max-width: 100%;
                            height: auto;
                        }
                        .alertConfirmParent{
                            width: 100%;
                            padding: 20px 30px;
                            text-align: `+btnAlign+`;
                            box-sizing: border-box;
                            background: #f2f2f2;
                        }
                        .alertConfirmBtn{
                            cursor: pointer;
                            padding: 8px 10px;
                            border: none;
                            border-radius: 2px;
                            color: `+btnColor+`;
                            background-color: `+btnBgColor+`;
                            box-shadow: 0 0 2px `+btnBgColor+`;
                        }
                    </style>
                `;
            
            var head = document.getElementsByTagName('head')[0];
            head.innerHTML += style		//头部加入样式,注意不可使用document.write()写入文件,否则出错
            
            const body = document.getElementsByTagName('body')[0];
                
            var alertMask = document.createElement('div');
            var alertContainer = document.createElement('div');
            var alertDes = document.createElement('div');
            var alertConfirmParent = document.createElement('div');
            var alertConfirmBtn = document.createElement('button');	
            
            body.append(alertMask);
            alertMask.classList.add('alertMask');
            alertMask.classList.add('box-sizing');
            
            alertMask.append(alertContainer);
            alertContainer.classList.add('alertContainer');
            alertContainer.classList.add('box-sizing');
                
            alertContainer.append(alertDes);
            alertDes.classList.add('alertDes');
            alertDes.classList.add('box-sizing');
            
            alertContainer.append(alertConfirmParent);
            alertConfirmParent.classList.add('alertConfirmParent');
            alertConfirmParent.classList.add('box-sizing');	
            
            alertConfirmParent.append(alertConfirmBtn);
            alertConfirmBtn.classList.add('alertConfirmBtn');
            alertConfirmBtn.classList.add('box-sizing');
            alertConfirmBtn.innerText = buttonVal;
            
            //加载提示信息	
            alertDes.innerHTML = msg;
            //关闭当前alert弹窗
            function alertBtnClick(){
                body.removeChild(alertMask);
                maskStyle = head.getElementsByClassName('mask-style')[0];
                head.removeChild(maskStyle);	//移除生成的css样式
                
            }
            alertConfirmBtn.addEventListener("click", alertBtnClick);
        }
    }

    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('content')}>
                    <div class={bem('content-layout')} />
                    <div class={bem('login-info')}>
                        {this.state === 'login' && (
                            <div>
                                <p>账号登录</p>
                                <Input class="wqms-mt20" placeholder="请输入手机号" v-model={this.username} trim={false}>
                                    <Icon type="ios-phone-portrait" slot="prefix" />
                                </Input>
                                <Input
                                    class="wqms-mt20"
                                    placeholder="请输入密码"
                                    trim={false}
                                    type={this.hidePassWord ? 'password' : 'text'}
                                    v-model={this.password}
                                >
                                    <Icon type="md-lock" slot="prefix" />
                                    <Icon
                                        type={this.hidePassWord ? 'md-eye-off' : 'md-eye'}
                                        slot="suffix"
                                        onClick={() => (this.hidePassWord = !this.hidePassWord)}
                                    />
                                </Input>
                                <div class={bem('change-state')} onClick={() => (this.state = 'findPassword')}>
                                    重置密码
                                </div>
                                <Button type="primary" long class={bem('login-btn')} onClick={this.login}>
                                    登录
                                </Button>
                            </div>
                        )}
                        {this.state === 'findPassword' && (
                            <div>
                                <p>重置密码</p>
                                <Input class="wqms-mt20" placeholder="请输入手机号" v-model={this.findUsername}>
                                    <Icon type="ios-phone-portrait" slot="prefix" />
                                </Input>
                                <div class={[bem('verification-code'), 'wqms-mt20']}>
                                    <Input placeholder="请输入验证码" v-model={this.verificationCode}>
                                        <Icon type="ios-phone-portrait" slot="prefix" />
                                    </Input>
                                    <Button type="primary" onClick={this.sendCode} class={{ 'ivu-btn-loading': this.remainingTime !== 0 }}>
                                        发送验证码{this.remainingTime !== 0 ? `(${this.remainingTime}s)` : ''}
                                    </Button>
                                </div>
                                <Input
                                    class="wqms-mt20"
                                    placeholder="请输入新密码"
                                    type={this.hidefindPassWord ? 'password' : 'text'}
                                    v-model={this.findPassWord}
                                >
                                    <Icon type="md-lock" slot="prefix" />
                                    <Icon
                                        type={this.hidefindPassWord ? 'md-eye-off' : 'md-eye'}
                                        slot="suffix"
                                        onClick={() => (this.hidefindPassWord = !this.hidefindPassWord)}
                                    />
                                </Input>
                                <Input
                                    class="wqms-mt20"
                                    placeholder="请再次确认密码"
                                    type={this.hidefindPassWordConfrim ? 'password' : 'text'}
                                    v-model={this.findPassWordConfrim}
                                >
                                    <Icon type="md-lock" slot="prefix" />
                                    <Icon
                                        type={this.hidefindPassWordConfrim ? 'md-eye-off' : 'md-eye'}
                                        slot="suffix"
                                        onClick={() => (this.hidefindPassWordConfrim = !this.hidefindPassWordConfrim)}
                                    />
                                </Input>
                                <div class={bem('change-state')} onClick={() => (this.state = 'login')}>
                                    登录
                                </div>
                                <Button type="primary" long class={bem('login-btn')} onClick={this.updatePassword}>
                                    重置密码
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
                <div class={bem('footer')}>
                    <div class={bem('footer-text')}>
                        <p>Copyright©2019水质在线监测系统平台 </p><a href="https://beian.miit.gov.cn/">浙ICP备19041879号-2</a>
                        <p>推荐使用谷歌浏览器</p>
                    </div>
                    <div class={bem('footer-qr')}>
                        <div>
                            <img src={require('../../assets/images/app.png')} alt="" />
                            {/*<qrcode value="http://www.baidu.com" options={{ width: this.width, margin: 0 }} />*/}
                            <p>水质监测App</p>
                        </div>
                    </div>
                </div>
                {/* <img v-if={this.logo_url === ""} class={bem('logo')} src={require('../../assets/images/logo.png')} height="81" style="margin-top:10px" /> */}
                <img class={bem('logo')} v-if={this.logo_url != ""}  src={this.logo_url} height="81" style="margin-top:10px" />
                <img class={bem('logo')} v-else src={require('../../assets/images/logo.png')} height="81" style="margin-top:10px" />
                <div class={bem('logo_head')} v-if={this.system_name != ""}>
                        <p v-if={this.system_name.length >= 11} class={bem('system-name-11')}>{this.system_name}</p>
                        <p v-else class={bem('system-name')}>{this.system_name}</p>
                        <p v-if={this.system_name.length >= 11} class={bem('english-system-name-11')}>{this.english_system_name}</p>
                        <p v-else class={bem('english-system-name')}>{this.english_system_name}</p>
                </div>
                <div class={bem('logo_head')} v-else>
                        <p v-if={this.system_name.length >= 11} class={bem('system-name-11')}>{this.system_name}</p>
                        <p v-else class={bem('system-name')}>水质在线监测系统平台</p>
                        <p v-if={this.system_name.length >= 11} class={bem('english-system-name-11')}>{this.english_system_name}</p>
                        <p v-else class={bem('english-system-name')}>Water quality online monitoring system platform</p>
                </div>
                
                {/* <div class="wqms-login-head"></div>
				<div class="wqms-login-content">
					<div class="wqms-login-img"></div>
					<div style="position: absolute;right: 10%;bottom: 25%;">
						<div class="wqms-login-wrapper">
							<div class="wqms-login-text"></div>
							<i-form style="margin-top:40px"  label-width={60} className="wqms-mt20">
								<form-item label="用户名：">
									<Input placeholder="用户名" v-model={this.username}>
									</Input>
								</form-item>
								<form-item label="密码：">
									<Input placeholder="密码" type="password" v-model={this.password} on-on-keypress={(e) => {
										e.keyCode === 13 && this.login()
									}}>
									</Input>
								</form-item>
							</i-form>

							<div class="text-center">
								<Button style="font-weight: bold;" onClick={this.login} type="primary" loading={this.loading} long class="wqms-mt20">登
									录</Button>
							</div>
						</div>
					</div>
				</div> */}
            </div>
        );
    }
}
